export default {"src":"/_next/static/media/join-us.298cbb9f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};